import { Client } from '@stomp/stompjs';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { createContext, useContext, useEffect, useState } from 'react';
import { usePrincipal } from '../principal/PrincipalContext';
import { useRsrc } from '../rsrc/RsrcContext';

const NotifContext = createContext();

export const NotifProvider = ({ children }) => {
  const [notifs, setNotifs] = useState([]);
  const [notifCount, setNotifCount] = useState(0);

  const { getToken, principal, org } = usePrincipal();
  const rsrc = useRsrc();

  useEffect(() => {
    if (!org) return;

    const protocol = window.location.protocol.includes('https') ? 'wss' : 'ws';
    const host = window.location.hostname === 'localhost' ? 'localhost:8080' : window.location.host;
    const endpoint = `${protocol}://${host}/skdr/api/stomp`;
    const headers = { 'Authorization': `Bearer ${getToken()}` };

    console.log(`Initializing Notification Service (${endpoint})`);

    const stompClient = new Client({
      brokerURL: endpoint,
      connectHeaders: headers,
      reconnectDelay: 1000, // If connection is severed, reconnect after 1s
      onConnect: () => {
        stompClient.subscribe(`/user/queue/${org}/notifs`, (message) => {
          const notifs = JSON.parse(message.body);
          handleStompNotifs(notifs);
        }, headers);
      },
      onStompError: frame => console.error('STOMP error', frame),
    });

    stompClient.activate();

    return () => {
      stompClient.deactivate();
    };
  }, [org]);

  const handleStompNotifs = (newNotifs) => {
    newNotifs = newNotifs.map((notif) => {
      if (notif.jobCat === 'EXPORT' && notif.eventType === 'FINISH_SUCCESS' && !notif.ack) {
        const module = notif.event.job.module;
        const exportId = notif.event.data;
        rsrc.download(module, exportId);
      }
      notif.verStartInstant = new Date(notif.verStartInstant).toISOString();
      return notif;
    });

    if (newNotifs.length > 0 || notifs.length > 0) {
      setNotifs(newNotifs);
    }
  };

  useEffect(() => {
    const rowsReq = {
      expr: ExprUtils.whereParams('username', principal.username, 'ack', false)
    };
    rsrc.rowCount('skdr', 'NOTIF', rowsReq).then((notifCount) => {
      setNotifCount(notifCount);
    });
  }, [notifs]);

  return (
    <NotifContext.Provider value={{ notifs, notifCount }}>
      {children}
    </NotifContext.Provider>
  );
};

export const useNotif = () => useContext(NotifContext);
